<div class="registration-layout">
  <img alt="imagedetails" src="assets/images/login-registration/registration-logo.svg" class="logo" />
  <div class="registration-container">
    <router-outlet></router-outlet>
  </div>
</div>
